///////////////////////////////////
// IMPORTS
///////////////////////////////////
// libraries
import React, { useEffect } from "react";
import { LoaderClock } from "@clockwise/web-commons/src/components/loader-clock";
import { withRouter, Router } from "found";

interface IContainer {}

interface IProps extends IContainer {
  router: Router;
}

///////////////////////////////////
// COMPONENT
///////////////////////////////////
const WebAppRedirectCmpt = (props: IProps) => {
  // ~-~-~-~-~-~-~-
  // Life cycle
  // ~-~-~-~-~-~-~-
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("path")) {
      const redirectPath = searchParams.get("path") as string;
      props.router.replace(`/${redirectPath}`);
    }
  }, []);

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return <LoaderClock />;
};

export const WebAppRedirect = withRouter(WebAppRedirectCmpt) as React.ComponentClass<{}>;
